
/**
 * Check if code is running in server-side rendering context
 * @returns {boolean} True if running in SSR, false if in browser
 */
export function isSSR() {
  return typeof window === 'undefined';
}
